module.exports = __webpack_public_path__ + "static/media/icon-moduleE7.09d0cdae.png";